export default __webpack_public_path__ + "static/media/history.c200002c.svg";